import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpParams,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService } from "./BaseService";
import { BehaviorSubject, Observable, from } from "rxjs";
import { switchMap } from 'rxjs/operators';
import { Router } from "@angular/router";
import { MatSnackBar } from '@angular/material/snack-bar';
import { KeycloakAuthService } from "./keycloak-auth.service"; import { get } from "jquery";
;

@Injectable({
  providedIn: "root",
})
export class AuthService extends BaseService {
  //authenticated: has a boolean value that shows if candidate or company user is logged in(Not for the admin)
  authenticated: BehaviorSubject<boolean> = new BehaviorSubject(
    !!sessionStorage.getItem("user")
  );
  //isAuthenticated$: the observale of our previous subject
  isAuthenticated$ = this.authenticated.asObservable();

  adminAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isAdminAuthenticated$ = this.adminAuthenticated.asObservable();

  /*isValidCompany and isValidCandidate: are boolean variables stored in the database thats informs us
    if the profile of a user is completed. This affects UI by changing the header profile tab options(*ngIf in the header component)
    Their values depends on the completion or not of some fields in their complete-profile form
    Lastly the value of a user when he's signed up is false in the database. He is navigated to the form so if he completes all the nessesary data
    the variable takes true or else it remains false. So in every log in or refresh in the angular front-end we fetch that information and store it to the variable
    to give the user the options that we want*/
  isValidCompany = false;
  isValidCandidate = false;
  /*signedName: is a string variable contains the name of the candidate or the company user that displays on header. 
    The name is fetched after a successful login of a candidate or a company and stored in this value*/
  signedName = "";
  /*isAdmin: is a boolean variable that takes true inside app-component.js navigation event hooks for admin components routes so to display the admin-header and admin-footer*/
  isAdmin = false;

  constructor(
    private http: HttpClient,
    private router: Router,
    private _snackBar: MatSnackBar,
    private keycloakAuth: KeycloakAuthService
  ) {
    super();
    const user = this.getSessionUser();
    this.adminAuthenticated.next(!!user && user.type === "admin");
  }

  // Session user + checkUser
  setSessionUser(user: any) {
    sessionStorage.setItem("user", JSON.stringify(user));
    this.authenticated.next(true);
    this.adminAuthenticated.next(user && user.type === "admin");
  }

  getSessionUser() {
    const raw = sessionStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  }

  clearSessionUser() {
    sessionStorage.removeItem("user");
    this.isValidCompany = false;
    this.isValidCandidate = false;
    this.signedName = "";
    this.authenticated.next(false);
    this.adminAuthenticated.next(false);
  }

  // FE sends KC claims to BE to map user and receive app-specific user object
  postCheckUser(payload: any) {
    return this.http.post<any>(`${this.apiEndPoint}/checkUser`, payload);
  }

  // Accessors (session-based)
  getCompanyId() {
    const u = this.getSessionUser();
    return u && u.companyId || null;
  }

  getCandidateKeycloakId() {
    const u = this.getSessionUser();
    return u && u.keycloakId || null;
  }

  isCompany() {
    const u = this.getSessionUser();
    return u && u.type === "company";
  }

  isCandidate() {
    const u = this.getSessionUser();
    return u && u.type === "candidate";
  }

  isAdminFunc() {

    const u = this.getSessionUser();
    return u && u.type === "admin";
  }

  AfterUnauthorizedRequestActions() {
    this.clearSessionUser();
    this.keycloakAuth.logout(window.location.origin + '/');
    this.router.navigate(["/home"]);
  }

  AfterAdminUnauthorizedRequestActions() {
    this.clearSessionUser
    this.keycloakAuth.logout(window.location.origin + '/');
    this.router.navigate(["/home"]);
  }

  AfterUnAuthorizedRequestUiMessage() {
    const statusMessage =
      "H Συνεδρία σας έχει λήξει. Κάντε σύνδεση για να συνεχίσετε";
    const panelStyle = "error-dialog";
    this._snackBar.open(statusMessage, null, {
      duration: 5000,
      verticalPosition: "top",
      horizontalPosition: "center",
      panelClass: [panelStyle],
    });
  }

  checkUserIsChamberUser(keycloakId: string): Observable<any> {
    return from(this.keycloakAuth.getToken()).pipe(
      switchMap(token => {
        const headers = new HttpHeaders({ 'Authorization': `Bearer ${token}` });
        const params = new HttpParams()
          .set('chamber_id', this.chamberId)
          .set('keycloak_id', keycloakId);
        return this.http.get<any>(
          `${this.pepSchemaApiBaseUrl}company/check-user`,
          { headers, params }
        );
      })
    );
  }

  checkUserIsAdmin(keycloakId: string): Observable<boolean> {
    return from(this.keycloakAuth.getToken()).pipe(
      switchMap(token => {
        const headers = new HttpHeaders({ 'Authorization': `Bearer ${token}` });
        const params = new HttpParams()
          .set('chamberId', this.chamberId)
          .set('app', 'CAREER');
        return this.http.get<boolean>(
          `${this.pepSchemaApiBaseUrl}chamber-app-managers/is-manager-check/${keycloakId}`,
          { headers, params }
        );
      })
    );
  }
  getCompanyActivationStatus(id) {
    return this.http.get<any>(
      `${this.apiEndPoint}/company/activationStatus` + "?id=" + id
    );
  }

  updateCompaniesActivationStatus(
    companiesUuids: string[],
    activationStatus: string
  ) {
    const body = {
      companiesUuids: companiesUuids,
      updatedStatus: activationStatus,
    };
    return this.http.patch(
      `${this.apiEndPoint}/company/adminSecure/updateCompanyActivationStatus`,
      body,
      { responseType: "text" }
    );
  }

  completeEmployer(employerInfo: any, uuid: any) {
    return this.http.patch<any>(
      `${this.apiEndPoint}/company/companySecure/${uuid}/completeProfile`,
      employerInfo
    );
  }

  getJobListByCompany(id, currentPage, pageSize) {
    return this.http.get<any>(
      `${this.apiEndPoint}/company/companySecure/` +
      id +
      `/jobposts?size=` +
      pageSize +
      `&page=` +
      currentPage +
      `&sort=creationDate,desc`
    );
  }

  getJobListByCompanyWithFilters(filters: any, currentPage, pageSize, status?) {
    const params = new HttpParams({
      fromObject: Object.entries(filters)
        .filter(([, value]) => value || value === 0)
        .reduce(
          (paramObj, [key, value]) => ({ ...paramObj, [key]: value }),
          {}
        ),
    });

    const companyId = this.getCompanyId();

    if (status === "all") {
      return this.http.get<any>(
        `${this.apiEndPoint}/company/companySecure/` +
        companyId +
        `/jobposts?size=` +
        pageSize +
        `&page=` +
        currentPage,
        { params: params }
      );
    } else {
      return this.http.get<any>(
        `${this.apiEndPoint}/company/companySecure/` +
        companyId +
        `/jobposts?size=` +
        pageSize +
        `&page=` +
        currentPage +
        `&status=` +
        status,
        { params: params }
      );
    }
  }

  getCompanyJobListByStatus(status, currentPage, pageSize) {
    const companyId = this.getCompanyId();
    return this.http.get<any>(
      `${this.apiEndPoint}/company/companySecure/` +
      companyId +
      `/jobposts?size=` +
      pageSize +
      `&page=` +
      currentPage +
      `&sort=creationDate,desc&status=` +
      status
    );
  }

  // option: firstName, creationDate
  // sort: asc, desc
  getCandidatesListWithFiltersAndSorting(
    option,
    sort,
    filters: any,
    currentPage: number,
    pageSize: number
  ) {
    const params = new HttpParams({
      fromObject: Object.entries(filters)
        .filter(([, value]) => value || value === 0)
        .reduce(
          (paramObj, [key, value]) => ({ ...paramObj, [key]: value }),
          {}
        ),
    });

    return this.http.get<any>(
      `${this.apiEndPoint}/candidate/companySecure/all?sort=` +
      option +
      "," +
      sort +
      `&page=` +
      currentPage +
      `&size=` +
      pageSize,
      { params: params }
    );
  }

  getAppliedCandidates(companyUuid, jobPostUuid, sort) {
    return this.http.get<any>(
      `${this.apiEndPoint}/company/companySecure/${companyUuid}/${jobPostUuid}/applications?size=100&orderType=` +
      sort
    );
  }

  updateJobStatus(jobPostUuid, status) {
    const formData: FormData = new FormData();
    formData.append("status", status);

    const req = new HttpRequest(
      "PATCH",
      `${this.apiEndPoint}/jobpost/companySecure/${jobPostUuid}/updateStatus`,
      formData,
      { responseType: "text" }
    );
    return this.http.request(req);
  }

  postAJobForm(jobInfo, companyUuid) {
    return this.http.post<any>(
      `${this.apiEndPoint}/jobpost/companySecure/${companyUuid}/create`,
      jobInfo
    );
  }

  updateJobPost(jobPostUuid, jobInfo) {
    return this.http.put<any>(
      `${this.apiEndPoint}/jobpost/companySecure/update/${jobPostUuid}`,
      jobInfo
    );
  }

  deletePostJob(jobPostUuid) {
    return this.http.delete<any>(
      `${this.apiEndPoint}/jobpost/companySecure/delete/${jobPostUuid}`
    );
  }

  //authed by candidate requests

  completeCandidate(userInfo: any, uuid) {
    return this.http.post<any>(
      `${this.apiEndPoint}/candidate/candidateSecure/${uuid}/completeProfile`,
      userInfo
    );
  }

  getCandidateAppliedJobs(sort) {
    const uuid = this.getCandidateKeycloakId();
    return this.http.get<any>(
      `${this.apiEndPoint}/candidate/candidateSecure/` +
      uuid +
      `/appliedJobs/?size=100&orderType=` +
      sort
    );
  }

  getJobApplicationInfo(jobPostUuid) {
    const uuid = this.getCandidateKeycloakId();
    return this.http.get<any>(
      `${this.apiEndPoint}/jobpost/candidateSecure/` +
      jobPostUuid +
      `/candidate/` +
      uuid
    );
  }

  postApplyJob(applyJob, candidateUuid) {
    return this.http.post<any>(
      `${this.apiEndPoint}/candidate/candidateSecure/${candidateUuid}/applyForJob`,
      applyJob
    );
  }

  getCandidateNotificationsPreferences(candidateUuid: any) {
    return this.http.get(
      `${this.apiEndPoint}/candidate/candidateSecure/${candidateUuid}/notificationsPreferences`
    );
  }

  postNotificationsPreferences(uuid, industiesId, tagsId) {
    return this.http.post(
      `${this.apiEndPoint}/candidate/candidateSecure/${uuid}/updateNotificationsPreferences`,
      { industriesId: industiesId, tagsId: tagsId },
      { responseType: "text" }
    );
  }

  updateNotificationsPreferencesStatus(uuid: any, status: boolean) {
    return this.http.patch(
      `${this.apiEndPoint}/candidate/candidateSecure/${uuid}/updateNotificationsStatus?notificationsStatus=${status}`,
      null,
      { responseType: "text" }
    );
  }

  updateCandidateStatus(status: any, candidateKeycloakIds: any[]) {
    const reqBody = {
      candidateKeycloakIds: candidateKeycloakIds,
      status: status,
    };
    return this.http.put(
      `${this.apiEndPoint}/candidate/adminSecure/updateStatus`,
      reqBody,
      { responseType: "text" }
    );
  }

  updateJobPostActivationStatus(activationStatus: any, jobPostsUuids: any[]) {
    const reqBody = {
      jobPostsUuids: jobPostsUuids,
      activationStatus: activationStatus,
    };

    return this.http.put(
      `${this.apiEndPoint}/jobpost/updateActivationStatus`,
      reqBody,
      { responseType: "text" }
    );
  }

  // get all job posts by activation status
  // used for admin's job posts handling
  getActiveJobPostsByActivationStatus(
    activationStatus: any,
    currentPage: number,
    pageSize: number
  ) {
    return this.http.get<any>(
      `${this.apiEndPoint}/jobpost/adminSecure/activationStatus` +
      "?size=" +
      pageSize +
      "&page=" +
      currentPage +
      "&sort=creationDate,desc" +
      "&activationStatus=" +
      activationStatus
    );
  }

  //public requests for data
  getCompanyInfo(id) {
    return this.http.get<any>(
      `${this.apiEndPoint}/company/completeProfile` + "?id=" + id
    );
  }

  checkCompanyProfile(companyData) {
    return this.http.post<any>(`${this.apiEndPoint}/company/checkCompanyProfile`, companyData);
  }
  getCompanyPublishedJobs(id, currentPage, pageSize) {
    return this.http.get<any>(
      `${this.apiEndPoint}/company/` +
      id +
      `/published/jobposts?page=` +
      currentPage +
      `&size=` +
      pageSize
    );
  }

  getJobPostsCount() {
    return this.http.get<any>(`${this.apiEndPoint}/jobpost/active/count`);
  }

  getJobPostsPopularLocations() {
    return this.http.get<any>(`${this.apiEndPoint}/jobpost/popularLocations`);
  }

  getMetaData(metadata: any) {
    return this.http.get<any>(`${this.apiEndPoint}/metadata`, metadata);
  }

  jobPostsList(filters: any, currentPage: number, pageSize: number) {
    const params = new HttpParams({
      fromObject: Object.entries(filters)
        .filter(([, value]) => value || value === 0)
        .reduce(
          (paramObj, [key, value]) => ({ ...paramObj, [key]: value }),
          {}
        ),
    });

    return this.http.get<any>(
      `${this.apiEndPoint}/jobpost/active` +
      "?size=" +
      pageSize +
      "&page=" +
      currentPage +
      "&sort=creationDate,desc",
      { params }
    );
  }

  // get jobs by industry and tag
  getRelatedJobs(
    relatedJobs: any,
    industryId: any,
    currentPage: number,
    pageSize: number
  ) {
    return this.http.get<any>(
      `${this.apiEndPoint}/jobpost` +
      "?industryId=" +
      industryId +
      "&page=" +
      currentPage +
      "&size=" +
      pageSize +
      "&sort=updateDate,desc"
    );
  }

  getJobDetailsByuuid(uuid: any) {
    return this.http.get<any>(`${this.apiEndPoint}/jobpost/` + uuid);
  }

  getLogo(context: string, field: string, uuid: any, timestamp: string) {
    const formData: HttpParams = new HttpParams({
      fromObject: { context, uuid, field, timestamp },
    });

    return `${this.apiEndPoint}/file?${formData.toString()}`;
  }

  //companies auth + candidate_searchable = true or specific candidate auth requests
  getCandidateProfile(candidateUuid = undefined) {
    if (candidateUuid === undefined) {
      const loggedInCandidateUuid = this.getCandidateKeycloakId();
      return this.http.get<any>(
        `${this.apiEndPoint}/candidate/candidateOrCompanySecure/${loggedInCandidateUuid}/completeProfile`
      );
    } else {
      return this.http.get<any>(
        `${this.apiEndPoint}/candidate/candidateOrCompanySecure/${candidateUuid}/completeProfile`
      );
    }
  }

  checkCandidateProfile(candidateKeycloakData) {
    return this.http.post<any>(
      `${this.apiEndPoint}/candidate/checkCandidateProfile`,
      candidateKeycloakData
    );
  }


  //file requests find out where and what kind of auth we need
  uploadApplicationJobCv(file: File, jobPostUuid: any) {
    const formData: FormData = new FormData();
    file ? formData.append("file", file, file.name) : null;
    formData.append("candidateUuid", this.getCandidateKeycloakId());
    formData.append("jobPostUuid", jobPostUuid);

    const req = new HttpRequest(
      "POST",
      `${this.apiEndPoint}/file/applicationCv`,
      formData,
      { responseType: "text" }
    );

    return this.http.request(req);
  }

  downloadCVOfJobApplication(jobuuid) {
    const candidateUuid: any = this.getCandidateKeycloakId();
    const jobPostUuid: any = jobuuid;
    const timestamp: any = new Date().getTime().toString();
    const formData: HttpParams = new HttpParams({
      fromObject: { candidateUuid, jobPostUuid, timestamp },
    });

    return `${this.apiEndPoint}/file/applicationCv?${formData.toString()}`;
  }

  downloadCVOfJobApplicationForCompany(jobuuid, candidateuuid) {
    const candidateUuid: any = candidateuuid;
    const jobPostUuid: any = jobuuid;
    const timestamp: any = new Date().getTime().toString();
    const formData: HttpParams = new HttpParams({
      fromObject: { candidateUuid, jobPostUuid, timestamp },
    });

    return `${this.apiEndPoint}/file/applicationCv?${formData.toString()}`;
  }

  postFile(file: File, field: string) {
    let finalId;

    if (this.getCompanyId()) {
      finalId = this.getCompanyId();
    } else {
      finalId = this.getCandidateKeycloakId();
    }

    const formData: FormData = new FormData();
    formData.append("file", file, file.name);
    formData.append("uuid", finalId);
    formData.append("field", field);

    const req = new HttpRequest("POST", `${this.apiEndPoint}/file`, formData, {
      responseType: "text",
    });

    return this.http.request(req);
  }

  downloadFile(context: string, field: string, timestamp: string, uuid: any) {
    const formData: HttpParams = new HttpParams({
      fromObject: { context, uuid, field, timestamp },
    });
    return `${this.apiEndPoint}/file?${formData.toString()}`;
  }


  //todo να δω ποια πεδια χρησιμοποιει οντως και αν ειναι μονο τα βασικα να τα παιρνω απο το session storage
  //θα πρεπει να τα εχω αποθηκεύση κιόλας εκεί
  getAdminProfile() {
    const response = {
      keycloakId: sessionStorage.getItem("keycloakId") || undefined,
      username: sessionStorage.getItem("username") || undefined,
      role: sessionStorage.getItem("role") || undefined,
    };
    return response;
  }

  getAllCompanies(gemiNumber, am, name, selectedTab, currentPage, pageSize) {
    let params = new HttpParams();
    if (gemiNumber != null) {
      params = params.set("gemiNumber", gemiNumber);
    }
    if (am != null) {
      params = params.set("am", am);
    }
    if (name != null) {
      params = params.set("name", name);
    }
    if (selectedTab != null) {
      params = params.set("activationStatus", selectedTab);
    }
    if (currentPage != null) {
      params = params.set("currentPage", currentPage);
    }
    if (pageSize != null) {
      params = params.set("pageSize", pageSize);
    }

    return this.http.get(`${this.apiEndPoint}/company/all`, { params });
  }
}
